import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { useQuery } from '@tanstack/react-query';

import { personKeys } from './person-keys';

import type { PersonDataResponse } from '../model';

export const usePersonData = () => {
  return useQuery({
    queryKey: personKeys.get(),
    queryFn: () => {
      return makeRequest<ResponseSuccess<PersonDataResponse>>({
        url: `${config.apiHost}/merchant-origination/api/v1/person/get`,
        httpMethod: 'POST',
        credentials: 'include',
      }).then((response) => response.payload);
    },
  });
};
